import { asSingleStyleConfig } from '../../../../utils/theme';
export var baseStyle = {
  transition: "all 0.15s ease-out",
  cursor: 'pointer',
  textDecoration: 'none',
  letterSpacing: '-0.2px',
  lineHeight: '24px',
  outline: 'none',
  color: 'blue.600',
  fontWeight: 'bold',
  _hover: {
    textDecoration: 'none'
  },
  _focus: {
    boxShadow: 'none',
    outline: 'none',
    textDecoration: 'none',
    background: 'blue.200',
    paddingTop: '.3rem',
    paddingBottom: '.3rem'
  }
};
export var Link = asSingleStyleConfig({
  baseStyle
});